<template>
  <el-row tag="span" class="er-date-range-filter--2">
    <el-row>
      <el-col tag="span" :span="18">
        <er-date-picker
          :value="getDatesRanges[0]"
          class="date-range-picker-1"
          size="mini"
          type="daterange"
          :format="displayFormat"
          :value-format="datePickerFormat"
          popper-class="er-date-range-filter__date-range-1"
          :picker-options="dateQueryPickerOptions"
          @input="handleChangeInDateRange($event, 0)"
        ></er-date-picker>
      </el-col>
      <el-col tag="span" :span="6">
        <el-tag class="el-tag-1">
          <slot name="range_1_value"></slot>
        </el-tag>
      </el-col>
    </el-row>
    <el-row>
      <el-col tag="span" :span="18">
        <div class="icon-container">
          <svg
            class="svg-icon-size"
            viewBox="0 0 39 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M38.5 19C38.5 29.2051 30.0057 37.5 19.5 37.5C8.99427 37.5 0.5 29.2051 0.5 19C0.5 8.7949 8.99427 0.5 19.5 0.5C30.0057 0.5 38.5 8.7949 38.5 19Z"
              fill="#F9F9F9"
              stroke="#FB8CB4"
            />
            <path
              d="M22 22.2375V31H24.5V22.2375H28.25L23.25 17.25L18.25 22.2375H22Z"
              fill="#FC196B"
            />
            <path
              d="M14.5 14.7624H10.75L15.75 19.7499L20.75 14.7624H17V5.99994H14.5V14.7624Z"
              fill="#FC196B"
            />
          </svg>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col tag="span" :span="18">
        <er-date-picker
          :value="getDatesRanges[1]"
          class="date-range-picker-2"
          type="daterange"
          :format="displayFormat"
          :value-format="datePickerFormat"
          size="mini"
          popper-class="er-date-range-filter__date-range-2"
          :picker-options="dateQueryPickerOptions"
          @input="handleChangeInDateRange($event, 1)"
        ></er-date-picker>
      </el-col>
      <el-col tag="span" :span="6">
        <el-tag class="el-tag-2">
          <slot name="range_2_value"></slot>
        </el-tag>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" style="margin-top:10px;">
      <er-button
        size="mini"
        :showLabel="true"
        :showIcon="true"
        btnType="save"
        @click="handleApplyEvent"
        :title="this.$t('Comn_apply')"
      >
        <p>
          {{
          this.$t("Comn_apply")
          }}
        </p>
      </er-button>
      <er-button btnType="cancel" size="mini" @click="handleCancelEvent">
        {{
        this.$t("Comn_cancel")
        }}
      </er-button>
    </el-row>
  </el-row>
</template>

<script>
import { DATE_OBJ_DATE_FORMAT_WITH_YEAR } from "@/utils/commonUtils";
export default {
  props: {
    value: {
      default: undefined
    },
    userTimeZoneOffset: {
      default: 0
    }
  },
  data: function() {
    return {
      dateRanges: undefined,
      displayFormat: DATE_OBJ_DATE_FORMAT_WITH_YEAR,
      datePickerFormat: "yyyy-MM-dd",
      momentDateFormat: "YYYY-MM-DD",
      selectedDateQuery: undefined,
      selectedDateRangeQuery2: undefined,
      checked: false
    };
  },
  computed: {
    dateRange2PickOptions() {
      return {
        previous_period: { id: "previous_period", text: "Previous Period" },
        previous_year: { id: "previous_year", text: "Previous Year" },
        custom: { id: "custom", text: "Custom" }
      };
    },
    getDefaultDateRanges() {
      return [
        [
          this.$moment()
            .subtract(1, "days")
            .format(this.momentDateFormat),
          this.$moment().format(this.momentDateFormat)
        ],
        [
          this.$moment()
            .subtract(2, "days")
            .format(this.momentDateFormat),
          this.$moment()
            .subtract(1, "days")
            .format(this.momentDateFormat)
        ]
      ];
    },
    getDatesRanges() {
      return this.dateRanges || this.value || this.getDefaultDateRanges;
    },
    computedSelectedDateQuery: function() {
      return this.selectedDateQuery || Object.values(this.dateQueryOptions)[0];
    },
    computedSelectedDateQuery2: function() {
      return (
        this.selectedDateRangeQuery2 ||
        Object.values(this.dateRange2PickOptions)[0]
      );
    },
    dateQueryOptions() {
      const getshortCutObj = (
        no,
        unit,
        customText = undefined,
        customId = undefined
      ) => {
        return {
          id: customId || no + unit,
          no,
          unit,
          text:
            customText || `${this.$t("Comn_last")} ${no} ${this.$tc(unit, 2)}`
        };
      };
      return [
        getshortCutObj(0, "days", "Custom", "custom"),
        getshortCutObj(2, "days"),
        getshortCutObj(3, "days"),
        getshortCutObj(5, "days"),
        getshortCutObj(1, "months"),
        getshortCutObj(3, "months"),
        getshortCutObj(6, "months")
      ].reduce((acc, option) => {
        acc[option.id] = option;
        return acc;
      }, {});
    },
    dateQueryPickerOptions() {
      const getshortCutObj = (
        no,
        unit,
        customText = undefined,
        customId = undefined
      ) => {
        return {
          id: customId || no + unit,
          no,
          unit,
          text:
            customText || `${this.$t("Comn_last")} ${no} ${this.$tc(unit, 2)}`
        };
      };
      const getFormat = momentObj => {
        return momentObj.format(this.momentDateFormat);
      };
      return {
        disabledDate: time => {
          const timeObj = this.$moment(time);
          return timeObj.isAfter(
            this.$moment()
              .utcOffset(this.userTimeZoneOffset)
              .endOf("hours")
          );
        },
        shortcuts: [
          getshortCutObj(2, "days"),
          getshortCutObj(3, "days"),
          getshortCutObj(5, "days"),
          getshortCutObj(1, "months"),
          getshortCutObj(3, "months"),
          getshortCutObj(6, "months")
        ].map(shortCut => {
          return {
            text: shortCut.text,
            onClick: picker => {
              const end = this.$moment();
              const start = this.$moment();
              start.subtract(shortCut.no, shortCut.unit);
              picker.$emit("pick", [getFormat(start), getFormat(end)]);
            }
          };
        })
      };
    }
  },
  methods: {
    getDatesRangesForPickedDateQuery(no, unit) {
      return [
        [
          this.$moment()
            .subtract(no, unit)
            .format(this.momentDateFormat),
          this.$moment()
            .subtract(0, unit)
            .format(this.momentDateFormat)
        ],
        [
          this.$moment()
            .subtract(2 * no + 1, unit)
            .format(this.momentDateFormat),
          this.$moment()
            .subtract(no + 1, unit)
            .format(this.momentDateFormat)
        ]
      ];
    },
    handleOnPickDateQuery(paramSelectedDateQueryOption) {
      this.selectedDateQuery = paramSelectedDateQueryOption;
      const { id, no, unit } = paramSelectedDateQueryOption;
      if (id === "custom") {
        return;
      }
      this.dateRanges = this.getDatesRangesForPickedDateQuery(no, unit);
    },
    handleChangeInDateRange(value, dateInputID) {
      if (!this.dateRanges) {
        this.dateRanges = [...this.value];
      }
      this.dateRanges.splice(dateInputID, 1, value);
    },
    handleChangeDaterange2(value) {
      this.selectedDateRangeQuery2 = value;
    },
    handleApplyEvent() {
      if (!this.dateRanges) {
        this.dateRanges = [...this.value];
      }
      this.$emit(
        "input",
        this.dateRanges.map(x =>
          x.map(y => this.$moment(y).format(this.momentDateFormat))
        )
      );
      this.$emit(
        "change",
        this.dateRanges.map(x =>
          x.map(y => this.$moment(y).format(this.momentDateFormat))
        )
      );
    },
    handleCancelEvent() {
      this.dateRanges = [...this.value];
      this.$emit(
        "cancel",
        this.dateRanges.map(x =>
          x.map(y => this.$moment(y).format(this.momentDateFormat))
        )
      );
    }
  }
};
</script>

<style lang="scss">
.er-date-range-filter__date-range-2 {
  top: 225px !important;
}
.er-date-range-filter__date-range-1,
.er-date-range-filter__date-range-2 {
  .el-picker-panel [slot="sidebar"] + .el-picker-panel__body,
  .el-picker-panel__sidebar + .el-picker-panel__body {
    margin-left: 120px;
  }
}
.er-date-range-filter--2 {
  display: flex;
  flex-direction: column;
  .el-row {
    margin-bottom: 5px;
    // width: 20%;
    // display: inline-block;
  }
  .date-range-picker-1 {
    &.is-active,
    &.is-active:hover {
      border-color: #233a73;
    }
  }
  .date-range-picker-2 {
    &.is-active,
    &.is-active:hover {
      border-color: #fc196b;
    }
  }
  .el-tag {
    height: 28px;
    line-height: 28px;
    margin-left: 10px;
  }
  .el-tag-1 {
    background-color: #233a73;
    border-color: #233a73;
    color: white;
  }
  .el-tag-2 {
    background-color: #fc196b;
    border-color: #fc196b;
    color: white;
  }
  .date-picker .el-range-input {
    width: 75px;
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2
    );
  }
  .el-range-editor--mini .el-range-separator {
    width: 50px;
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2
    );
  }
  .icon-container {
    display: table;
    margin: auto;
    svg {
      display: table-cell;
    }
  }
}
</style>
